import ReportsIcon from '@mui/icons-material/FolderCopyOutlined';
import Container from '@mui/material/Container';

import SectionTitle from '@/components/SectionTitle/SectionTitle';
import usePageTitle from '@/hooks/usePageTitle';
import MyReportsSection from '@/sections/MyReports';

const MyReports = () => {
  usePageTitle('Mis reportes');

  return (
    <Container maxWidth="xxl">
      <SectionTitle title="Mis reportes" mt={5}>
        <ReportsIcon fontSize="large" />
      </SectionTitle>

      <MyReportsSection />
    </Container>
  );
};

export default MyReports;
